/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovQ2xpZW50cy9yZW50LWhlcm8vd2ViLWFwcGxpY2F0aW9uL3NyYy9hcHAvYXBwLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0M6L0NsaWVudHMvcmVudC1oZXJvL3dlYi1hcHBsaWNhdGlvbi9zcmMvYXBwL2FwcC5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// C:/Clients/rent-hero/web-application/src/$$_gendir/app/app.component.scss.shim.ngstyle.ts